import {connect} from "src/store";
export default connect;